import H from 'history'
import React, { Fragment } from 'react'
import { EntitledToView } from '../entitlements/EntitledToView'
import { BreachEvent } from 'common/events/breachEventTypes'
import { BreachNotificationWrapper } from './components/BreachNotificationWrapper'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import { ImageSourceWithCaptions } from 'common/client-data-types/image-item'
import { StyledGalleryBreach, StyledGalleryBreachNotification } from './GalleryBreach.styled'

interface OwnProps {
    isPremium: boolean
    location: H.Location
    images: ImageSourceWithCaptions[]
    onEvent: (event: BreachEvent) => void
    children: (
        content: {
            images: ImageSourceWithCaptions[]
        },
        entitled: boolean
    ) => React.ReactElement<any>
    publicationId: string
    slug: string
}

export type Props = OwnProps
export const InternalGalleryBreach: React.FC<Props> = props => {
    const { isPremium, location, images, onEvent, children, publicationId, slug } = props
    const creativeName = 'launch'
    const deal = 'launch deal'

    return (
        <EntitledToView
            isPremium={isPremium}
            articleSlug={slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                creativeName,
                deal,
                location,
                onEvent
            )}
            entitled={() => {
                return children({ images }, true)
            }}
            notEntitled={() => {
                const { children } = props
                return (
                    <Fragment>
                        <StyledGalleryBreach>{children({ images: [] }, false)}</StyledGalleryBreach>
                        <StyledGalleryBreachNotification>
                            <BreachNotificationWrapper
                                breachDeal={deal}
                                breachCreativeName={creativeName}
                                articleId={publicationId}
                                onEvent={onEvent}
                            />
                        </StyledGalleryBreachNotification>
                    </Fragment>
                )
            }}
        />
    )
}

export const GalleryBreach: React.ComponentType<OwnProps> = InternalGalleryBreach
GalleryBreach.displayName = 'GalleryBreach'
